import React, { useCallback, useEffect, useState } from 'react';
import { $getSelection, $isElementNode, $isRangeSelection, FORMAT_ELEMENT_COMMAND, type ElementFormatType, OUTDENT_CONTENT_COMMAND, INDENT_CONTENT_COMMAND } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $isParentElementRTL } from '@lexical/selection';
import { $isLinkNode } from '@lexical/link';
import { getSelectedNode } from '../../../utils/utils';
import { elementFormatName } from '../constants/constants';
import { $findMatchingParent, mergeRegister } from '@lexical/utils';
import { Select } from 'baseui/select';
import { SELECT_PROPS } from '../../../constants/constants';
const ELEMENT_FORMAT_OPTIONS = [{
  formatType: 'left',
  formatName: 'Left Align'
}, {
  formatType: 'center',
  formatName: 'Center Align'
}, {
  formatType: 'right',
  formatName: 'Right Align'
}, {
  formatType: 'justify',
  formatName: 'Justify Align'
}, {
  formatType: 'indent',
  formatName: 'Indent'
}, {
  formatType: 'outdent',
  formatName: 'Outdent'
}];
const ElementFormatDropDown = () => {
  const [editor] = useLexicalComposerContext();
  const [isRTL, setIsRTL] = useState(false);
  const [elementFormat, setElementFormat] = useState<ElementFormatType>('left');
  const [isEditable, setIsEditable] = useState(() => editor.isEditable());
  const updateToolbar = useCallback(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }
    setIsRTL($isParentElementRTL(selection));
    const node = getSelectedNode(selection);
    const parent = node.getParent();
    let matchingParent;
    if ($isLinkNode(parent)) {
      matchingParent = $findMatchingParent(node, parentNode => $isElementNode(parentNode) && !parentNode.isInline());
    }
    setElementFormat(($isElementNode(matchingParent) ? matchingParent.getFormatType() : $isElementNode(node) ? node.getFormatType() : parent?.getFormatType()) || 'left');
  }, []);
  useEffect(() => {
    return mergeRegister(editor.registerEditableListener(editable => {
      setIsEditable(editable);
    }), editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        updateToolbar();
      });
    }));
  }, [updateToolbar, editor]);
  return <Select disabled={!isEditable} {...SELECT_PROPS} options={ELEMENT_FORMAT_OPTIONS} labelKey="formatType" valueKey="formatName" onChange={({
    value
  }) => {
    const currElementFormat = value[0].formatType;
    if (currElementFormat === ('outdent' as ElementFormatType)) {
      editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
    } else if (currElementFormat === ('indent' as ElementFormatType)) {
      editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
    } else {
      editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, currElementFormat);
    }
    setElementFormat(currElementFormat);
  }} value={[{
    formatType: elementFormat,
    formatName: elementFormatName[(elementFormat as keyof typeof elementFormatName)]
  }]} />;
};
export default ElementFormatDropDown;